var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2975 8.0005V6.29717C16.2975 5.092 15.2696 4 14.0003 4C12.731 4 11.7031 5.02783 11.7031 6.29717V7.99933",
    stroke: "#3158F2",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7002 13.3328H11.2985C10.581 13.3328 10 12.7518 10 12.0343V9.2985C10 8.581 10.581 8 11.2985 8H16.7013C17.4188 8 17.9998 8.581 17.9998 9.2985V12.0343C17.9998 12.7518 17.4177 13.3328 16.7002 13.3328Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5781 24.9948H6.41146C4.15629 24.9948 2.32812 23.1666 2.32812 20.9115C2.32812 18.6563 4.15629 16.8281 6.41146 16.8281H21.5781C23.8333 16.8281 25.6615 18.6563 25.6615 20.9115C25.6615 23.1666 23.8333 24.9948 21.5781 24.9948Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2899 20.9103C21.2899 20.7528 21.1627 20.6256 21.0052 20.6268C20.8477 20.6268 20.7205 20.754 20.7205 20.9115C20.7205 21.069 20.8477 21.1961 21.0052 21.1961C21.1627 21.1961 21.2899 21.069 21.2899 20.9103",
    stroke: "#F1F3F4",
    strokeWidth: 1.89583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.618 20.9103C16.618 20.7528 16.4908 20.6256 16.3333 20.6268C16.1758 20.6268 16.0487 20.754 16.0487 20.9115C16.0487 21.069 16.1758 21.1961 16.3333 21.1961C16.4897 21.1961 16.618 21.069 16.618 20.9103",
    stroke: "#F1F3F4",
    strokeWidth: 1.89583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9461 20.9103C11.9461 20.7528 11.819 20.6256 11.6615 20.6268C11.504 20.6268 11.3768 20.754 11.3768 20.9115C11.3768 21.069 11.504 21.1961 11.6615 21.1961C11.8178 21.1961 11.9461 21.069 11.9461 20.9103",
    stroke: "#F1F3F4",
    strokeWidth: 1.89583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28988 20.9103C7.28988 20.7528 7.16271 20.6256 7.00521 20.6268C6.84771 20.6268 6.72054 20.754 6.72054 20.9115C6.72054 21.069 6.84771 21.1961 7.00521 21.1961C7.16154 21.1961 7.28988 21.069 7.28988 20.9103",
    stroke: "#F1F3F4",
    strokeWidth: 1.89583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtp);
export default __webpack_public_path__ + "static/media/otp.da17519aa7f45d0c682b6adcdf93e0f6.svg";
export { ForwardRef as ReactComponent };